module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="block"><input type="radio" name="radio" data-input="'+
((__t=( transientName ))==null?'':__t)+
'-radio" value="'+
((__t=( id ))==null?'':__t)+
'" id="'+
((__t=( id ))==null?'':__t)+
'"> <span class="name">'+
((__t=( transientName ))==null?'':__t)+
'</span></div><div> ';
 if ( !transientFree ) { 
__p+=' <dl> ';
 if ( registrationFee !== "" ) { 
__p+=' <dt class="registration-fee-label">'+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "Registration fee:") ))==null?'':__t)+
'</dt><dd class="registration-fee">'+
((__t=( transientFormatRegistrationFee ))==null?'':__t)+
' '+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "(tax incl.)")))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( fixedPrice ) { 
__p+=' <dt class="monthly-price-label">'+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "Total price:") ))==null?'':__t)+
'</dt><dd class="montly-price">'+
((__t=( transientFormatPackagePrice ))==null?'':__t)+
' '+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "(tax incl.)")))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dt class="monthly-price-label">'+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "Monthly price:") ))==null?'':__t)+
'</dt><dd class="montly-price">'+
((__t=( transientFormatMonthlyPrice ))==null?'':__t)+
' '+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "(tax incl.)")))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl> ';
 if (prepaid && installerAddress ) { 
__p+=' <p class="payment-note"><small>'+
((__t=(i18n.tc( "SubscriptionPackageSelection", "The dealer agreement you choose will be invoiced your company billing account when the customer claims the device. The invoice will be sent to %s." ).format(installerAddress) ))==null?'':__t)+
'</small></p> ';
 } 
__p+=' ';
 if ( registrationFee !== "" ) { 
__p+=' <p class="payment-note"><small>'+
((__t=(i18n.tc( "SubscriptionPackageRadioButton", "The first invoice consists of a %s month subscription and the registration fee." ).format(duration) ))==null?'':__t)+
'</small></p> ';
 } else { 
__p+=' <p class="payment-note"><small>'+
((__t=(i18n.tc( "SubscriptionPackageRadioButton", "The first invoice consists of a %s month subscription." ).format(duration) ))==null?'':__t)+
'</small></p> ';
 } 
__p+=' ';
 } 
__p+=' ';
 if ( transientNextPaymentStateChange === "FREE_TO_PAYMENT" ) { 
__p+=' <p class="payment-note"><small>'+
((__t=(i18n.tc( "SubscriptionPackageRadioButton", "The subscription is prepaid for %s months." ).format(duration) ))==null?'':__t)+
'</small></p> ';
 } 
__p+=' </div>';
}
return __p;
};
